import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { OrderSideEnum } from '@modules/orders-module/enums/order-side.enum'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { TranslatePipe } from '@ngx-translate/core'
import { HighlightDirective } from '@shared/directives/higlight.directive'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'

@Component({
	selector: 'app-info-options-order-header',
	templateUrl: './info-options-order-header.component.html',
	styleUrl: './info-options-order-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, HighlightDirective],
})
export class InfoOptionsOrderHeaderComponent {
	protected readonly orderSideEnum: typeof OrderSideEnum = OrderSideEnum
	protected readonly orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum

	@Input() order: OrderInterface | null = null
}
